import { colors } from '../../colors';
var address = {
  addressColor: colors.darkViolet
};
export default address;